"use client"

import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { resolvedTheme } = useTheme();

  // Use resolvedTheme so we know the actual applied theme (light/dark)
  const toasterTheme = (resolvedTheme as ToasterProps["theme"]) || "light";

  return (
    <Sonner
      theme={toasterTheme}
      className="toaster group"
      richColors
      toastOptions={{
        classNames: {
          // Use important-tailwind to try to override inline styles or variant classes
          toast: "group toast !bg-white dark:!bg-background text-foreground border-border shadow-lg",
          description: "text-muted-foreground",
          actionButton: "bg-primary text-primary-foreground",
          cancelButton: "bg-muted text-muted-foreground",
        },
      }}
      {...props}
    />
  );
}

export { Toaster }
